import React from 'react';

export type PayMethod = 'SBP' | 'CRYPTO';

// Официальный знак СБП + биткоин для крипты
const SbpIcon: React.FC = () => (
  <svg width="18" height="22" viewBox="0 0 97 120" fill="none" aria-hidden="true">
    <path d="M0 26.12l14.532 25.975v15.844L.017 93.863 0 26.12z" fill="#5B57A2" />
    <path d="M55.797 42.643l13.617-8.346 27.868-.026-41.485 25.414V42.643z" fill="#D90751" />
    <path d="M55.72 25.967l.077 34.39-14.566-8.95V0l14.49 25.967z" fill="#FAB718" />
    <path d="M97.282 34.271l-27.869.026-13.693-8.33L41.231 0l56.05 34.271z" fill="#ED6F26" />
    <path d="M55.797 94.007V77.322l-14.566-8.78.008 51.458 14.558-25.993z" fill="#63B22F" />
    <path d="M69.38 85.737L14.531 52.095 0 26.12l97.223 59.583-27.844.034z" fill="#1487C9" />
    <path d="M41.24 120l14.556-25.993 13.583-8.27 27.843-.034L41.24 120z" fill="#017F36" />
    <path d="M.017 93.863l41.333-25.32-13.896-8.526-12.922 7.922L.017 93.863z" fill="#984995" />
  </svg>
);

// Официальный знак Bitcoin (simple-icons, CC0) — круг с вырезанной ₿ одним path
const CryptoIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="#F7931A"
      d="M23.638 14.904c-1.602 6.43-8.113 10.34-14.542 8.736C2.67 22.05-1.244 15.525.362 9.105 1.962 2.67 8.475-1.243 14.9.358c6.43 1.605 10.342 8.115 8.738 14.548v-.002zm-6.35-4.613c.24-1.59-.974-2.45-2.64-3.03l.54-2.153-1.315-.33-.525 2.107c-.345-.087-.705-.167-1.064-.25l.526-2.127-1.32-.33-.54 2.165c-.285-.067-.565-.132-.84-.2l-1.815-.45-.35 1.407s.975.225.955.236c.535.136.63.486.615.766l-1.477 5.92c-.075.166-.24.406-.614.314.015.02-.96-.24-.96-.24l-.66 1.51 1.71.426.93.242-.54 2.19 1.32.327.54-2.17c.36.1.705.19 1.05.273l-.51 2.154 1.32.33.545-2.19c2.24.427 3.93.257 4.64-1.774.57-1.637-.03-2.58-1.217-3.196.854-.193 1.5-.76 1.68-1.93h.01zm-3.01 4.22c-.404 1.64-3.157.75-4.05.53l.72-2.9c.896.23 3.757.67 3.33 2.37zm.41-4.24c-.37 1.49-2.662.735-3.405.55l.654-2.64c.744.18 3.137.524 2.75 2.084v.006z"
    />
  </svg>
);

// Минимальная сумма для оплаты криптой (≈ $10 — ограничение Cardlink).
export const CRYPTO_MIN_RUB = 1000;

// Выбор способа оплаты: СБП — сразу форма СБП у Cardlink; Crypto — страница
// Cardlink со всеми включенными способами (криптокошелек выбирает клиент).
// cryptoDisabled: сумма ниже минималки крипты — кнопка серая и некликабельная.
export const PaymentMethodSelect: React.FC<{
  value: PayMethod;
  onChange: (v: PayMethod) => void;
  cryptoDisabled?: boolean;
}> = ({ value, onChange, cryptoDisabled = false }) => {
  const options: Array<{ key: PayMethod; label: string; icon: React.ReactNode }> = [
    { key: 'SBP', label: 'СБП', icon: <SbpIcon /> },
    { key: 'CRYPTO', label: 'Crypto', icon: <CryptoIcon /> },
  ];

  return (
    <div>
      <h3
        className="mb-2"
        style={{ fontFamily: 'Manrope, sans-serif', fontWeight: 700, fontSize: '17px', lineHeight: '22px', letterSpacing: '-0.2px', color: '#1A1D1A' }}
      >
        Способ оплаты
      </h3>
      <div className="grid grid-cols-2 gap-2">
        {options.map((o) => {
          const active = value === o.key;
          const disabled = o.key === 'CRYPTO' && cryptoDisabled;
          return (
            <button
              key={o.key}
              onClick={() => !disabled && onChange(o.key)}
              disabled={disabled}
              className={`flex flex-col items-center justify-center transition-all ${disabled ? '' : 'active:scale-[0.98]'}`}
              style={{
                height: 56,
                borderRadius: 16,
                border: active && !disabled ? '1.5px solid #3657F0' : '1px solid #E1E3E5',
                background: disabled ? '#F4F5F6' : active ? 'rgba(54, 87, 240, 0.05)' : '#FFFFFF',
                cursor: disabled ? 'default' : 'pointer',
              }}
            >
              <span className="flex items-center justify-center gap-2.5" style={{ opacity: disabled ? 0.4 : 1 }}>
                {o.icon}
                <span style={{ fontSize: 15, fontWeight: 700, color: '#1A1D1A' }}>{o.label}</span>
              </span>
              {disabled && (
                <span style={{ fontSize: 11, lineHeight: '13px', color: '#818384', marginTop: 2 }}>
                  от {CRYPTO_MIN_RUB.toLocaleString('ru-RU')} ₽
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};
